export function CurrencyFormat(value) {
    if (!value) return;
    var strVal = value.replace(/\.,/g,'');
    var intVal = parseInt(strVal); 
    var newVal = intVal.toLocaleString('en-US', { minimumFractionDigits: 2 });
    return `RD$ ${newVal}`;
}

